import { NestedTreeControl } from '@angular/cdk/tree';
import { Component, EventEmitter, Output } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { OrganizationUnitDto, OrganizationUnitServiceProxy } from '@shared/service-proxies/service-proxies';
@Component({
  selector: 'app-organization-tree-radio-button',
  templateUrl: './organization-tree-radio-button.component.html',
  styleUrls: ['./organization-tree-radio-button.component.css']
})
export class OrganizationTreeRadioButtonComponent {
  @Output() clicked = new EventEmitter<OrganizationUnitDto>();
  treeControl = new NestedTreeControl<OrganizationUnitDto>(node => node.children);
  dataSource = new MatTreeNestedDataSource<OrganizationUnitDto>();

  constructor(
    private _organizationUnitServiceProxy: OrganizationUnitServiceProxy
  ) {
    this.BindOrganizationUnits();

  }

  hasChild = (_: number, node: OrganizationUnitDto) => !!node.children && node.children.length > 0;


  BindOrganizationUnits() {
    this._organizationUnitServiceProxy
      .GetOrganizationUnitTreeData().subscribe((result: OrganizationUnitDto[]) => {
        this.dataSource.data = result;
      });
  }

  haveChecked(node: OrganizationUnitDto) {
    return (
      node.code == "00001"
      ||
      node.code == "00001.00001"
      ||
      node.code == "00001.00001.00001"
      ||
      node.code == "00001.00001.00002"
      ||
      node.code == "00001.00001.00003"
    );
  }

  SelectionToggle(node: OrganizationUnitDto) {

    this.clicked.emit(node);
  }

}

